export const profileDataFields = [
  "avatar",
  "first_name",
  "last_name",
  "email",
  "phone",
  "password",
  "confirm_password",
];
